// TODO: Drops legacy storage key once we fully drop mobile app build < 268
const LEGACY_STATUS_BAR_HEIGHT_KEY = 'device-statusBarHeight';
const LEGACY_SAFE_AREA_INSET_BOTTOM_KEY = 'device-safeAreaInsetBottom';
const LEGACY_BUILD_VERSION_KEY = 'mBuildVersion';
const LEGACY_PLATFORM_OS_KEY = 'mPlatformOS';
(function(MobileDeviceUtils) {
    function getDeviceLanguages() {
        var _window_MOBILE;
        if (((_window_MOBILE = window.MOBILE) === null || _window_MOBILE === void 0 ? void 0 : _window_MOBILE.deviceLanguages) != null) return window.MOBILE.deviceLanguages;
        return [];
    }
    MobileDeviceUtils.getDeviceLanguages = getDeviceLanguages;
    function getStatusBarHeight() {
        var _window_MOBILE;
        if (((_window_MOBILE = window.MOBILE) === null || _window_MOBILE === void 0 ? void 0 : _window_MOBILE.statusBarHeight) != null) return window.MOBILE.statusBarHeight;
        const stored = localStorage.getItem(LEGACY_STATUS_BAR_HEIGHT_KEY);
        return stored == null ? null : Number(stored);
    }
    MobileDeviceUtils.getStatusBarHeight = getStatusBarHeight;
    function getSafeAreaInsetBottom() {
        var _window_MOBILE;
        if (((_window_MOBILE = window.MOBILE) === null || _window_MOBILE === void 0 ? void 0 : _window_MOBILE.safeAreaInsetBottom) != null) return window.MOBILE.safeAreaInsetBottom;
        const stored = localStorage.getItem(LEGACY_SAFE_AREA_INSET_BOTTOM_KEY);
        return stored == null ? null : Number(stored);
    }
    MobileDeviceUtils.getSafeAreaInsetBottom = getSafeAreaInsetBottom;
    function getBuildNumber() {
        var _window_MOBILE;
        if (((_window_MOBILE = window.MOBILE) === null || _window_MOBILE === void 0 ? void 0 : _window_MOBILE.buildVersion) != null) return Number(window.MOBILE.buildVersion);
        const stored = localStorage.getItem(LEGACY_BUILD_VERSION_KEY);
        return stored == null ? null : Number(stored);
    }
    MobileDeviceUtils.getBuildNumber = getBuildNumber;
    function getPlatform() {
        var _window_MOBILE;
        if (((_window_MOBILE = window.MOBILE) === null || _window_MOBILE === void 0 ? void 0 : _window_MOBILE.platformOS) != null) return window.MOBILE.platformOS;
        return localStorage.getItem(LEGACY_PLATFORM_OS_KEY);
    }
    MobileDeviceUtils.getPlatform = getPlatform;
})(MobileDeviceUtils || (MobileDeviceUtils = {}));
export var MobileDeviceUtils;
